// extracted by mini-css-extract-plugin
module.exports = {"DesktopMenuMain":"DesktopMenu_DesktopMenuMain__wpI8g"};